import React from 'react';
import { ButtonSpinner } from './LoadingButton';
import './AiMatchProcessingBar.css';

/**
 * Sticky processing indicator while AI rematch or list refresh is running.
 */
export default function AiMatchProcessingBar({
  matching = false,
  refreshing = false,
  label,
}) {
  if (!matching && !refreshing) return null;

  const text =
    label ||
    (matching
      ? 'AI matching in progress — scoring candidates against the job…'
      : 'Refreshing matches…');

  return (
    <div
      className={`ai-match-process-bar ${matching ? 'is-matching' : 'is-refreshing'}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="ai-match-process-bar__pulse" aria-hidden />
      <ButtonSpinner className="ai-match-process-bar__spinner" />
      <span className="ai-match-process-bar__text">{text}</span>
      <span className="ai-match-process-bar__track" aria-hidden>
        <span className="ai-match-process-bar__indeterminate" />
      </span>
    </div>
  );
}
